import { render } from "./RepoDetails.vue?vue&type=template&id=2be4e82a&scoped=true"
import script from "./RepoDetails.vue?vue&type=script&lang=js"
export * from "./RepoDetails.vue?vue&type=script&lang=js"

import "./RepoDetails.vue?vue&type=style&index=0&id=2be4e82a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Esther Ibom\\Desktop\\vue-exam\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be4e82a"]])

export default __exports__